import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PartnerUpdateReward, ReferralActionResponse } from 'types/api'
import { BaseParams } from 'types/utils'

export function useUpdatePartnerReward() {
  const queryClient = useQueryClient()

  async function updatePartnerReward({
    id,
    body
  }: BaseParams<[PartnerUpdateReward, ReferralActionResponse], 'PATCH'>) {
    const response = await apiClient.patch<ReferralActionResponse>(
      `${SNA_PREFIX}partners/${id}/update-reward`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: updatePartnerReward,
    onSuccess: (data, variables) => {
      variables.params?.onSuccess?.(data)
      // Invalidate queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['partners'] })
      // Also invalidate all partner-related queries
      queryClient.invalidateQueries({
        predicate: (query) =>
          Array.isArray(query.queryKey) && query.queryKey[0] === 'partners'
      })
      queryClient.invalidateQueries({ queryKey: ['referrals'] })
    },
    onError: (_, variables) => {
      variables.params?.onError?.()
    }
  })
}
